/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function MemberAdd(props) {
  const { login, onClosePop,seq } = props;
  const token = localStorage.getItem("token");
  const [showMemberSearch, setShowMemberSearch] = useState(false);

  const [point, setPoint] = useState(0); //+
  const [type, setType] = useState("type"); //+
  const [cname, setCname] = useState('cname'); //+
  const [mname, setMname] = useState("mname"); //+

  const onSubmit = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/point_edit",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        seq: seq, 
        point: point,
      }
    );
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "변경되었습니다.", showCloseButton: true }).then(
        (result) => {
          onClosePop();
        }
      );
    }
  };

  // Load data
  const load_data = async () => {

    let result = await axios.post(
    configState.api + "/gympass_admin/point_one",
    {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      seq: seq,
    });

    if (result.data.success === 1) {
        setPoint(result.data.row.point);
        setMname(result.data.row.mname);
        setType(result.data.row.type);
    } else {
      Swal.fire(result.data.msg);
      return;
    }

  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Box>    

      <Box
        css={css`
          padding: 20px 60px;
        `}
      >
        <Box>
          센터명 : {cname}
        </Box>

        <Box>
          고객명 : {mname}
        </Box>

        <Box>
          포인트구분 : {type}
        </Box>
        
        {/* 포인트 */}
        <FormControl
          fullWidth
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="point"
            label="포인트"
            size="small"
            autoComplete="off"
            value={point}
            onChange={(e) => setPoint(e.target.value)}
            sx={{ width: 260 }}
          ></TextField>
        </FormControl>
        
        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberAdd;
